import * as types from "../actionTypes/appActionTypes";
import initialState from "./appInitialState";

/**
 * appReducer reducer takes current state and action and
 * returns a new state for the application object in the store
 * @param state initial state of the application store
 * @param action function to dispatch to store
 * @return {Object} new state or initial state*/
export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case types.APP_FIRST_LOGIN: {
      const { isFirstLogin } = action;

      return {
        ...state,
        isFirstLogin,
      };
    }

    case types.APP_ADD_NOTIFICATION: {
      const { notification } = action;

      if (
        state.notifications.find(
          (n) => n.type !== action.notification && n.id === notification.id,
        )
      ) {
        return state;
      }

      return {
        ...state,
        notifications: [...state.notifications, notification],
      };
    }

    case types.APP_REMOVE_NOTIFICATION: {
      const { typeNotification, id } = action;
      return {
        ...state,
        notifications: state.notifications.filter(
          (n) => n.type !== typeNotification || n.id !== id,
        ),
      };
    }

    case types.APP_CLEAN_NOTIFICATION:
      return {
        ...state,
        notifications: [],
      };

    case types.OPEN_WARNING_MODAL:
      return {
        ...state,
        warningModal: {
          ...action.params,
          isOpen: true,
        },
      };

    case types.CLOSE_WARNING_MODAL:
      return {
        ...state,
        warningModal: {
          ...state.warningModal,
          isOpen: false,
        },
      };

    case types.SHOW_UPDATE_DIALOG:
    case types.SHOW_MIGRATION_DIALOG:
    case types.SHOW_REFRESH_MODAL: {
      let variant = action.params?.variant ?? state.refreshModal.variant;
      if (action.type === types.SHOW_UPDATE_DIALOG) {
        variant = "update";
      } else if (action.type === types.SHOW_MIGRATION_DIALOG) {
        variant = "migration";
      }

      return {
        ...state,
        refreshModal: {
          variant,
          ...(action.params || {}),
          isOpen: true,
        },
      };
    }

    case types.HIDE_UPDATE_DIALOG:
    case types.HIDE_MIGRATION_DIALOG:
    case types.HIDE_REFRESH_MODAL:
      return {
        ...state,
        refreshModal: {
          ...state.refreshModal,
          isOpen: false,
        },
      };

    case types.TOGGLE_UPDATE_DIALOG:
    case types.TOGGLE_MIGRATION_DIALOG:
    case types.TOGGLE_REFRESH_MODAL: {
      let defaultVariant = state.refreshModal.variant;
      if (action.type === types.TOGGLE_UPDATE_DIALOG) {
        defaultVariant = "update";
      } else if (action.type === types.TOGGLE_MIGRATION_DIALOG) {
        defaultVariant = "migration";
      }

      return {
        ...state,
        refreshModal: {
          ...state.refreshModal,
          variant: action.variant || defaultVariant,
          isOpen: !!action.isOpen,
        },
      };
    }

    case types.SET_SIDEBAR_EXPANDED:
      return {
        ...state,
        sidebarExpanded: action.expanded,
      };

    default:
      return state;
  }
}
